export const importStatuses = [
  'Создан', 'Файлы загружены', 'В очереди разбора', 'Разбор', 'Готов к проверке',
  'Утверждён', 'В очереди применения', 'Применение', 'Применён',
  'Частично применён', 'Ошибка разбора', 'Ошибка применения', 'Отменён'
]
export const importStatusValues = Object.freeze({ Uploaded: 1, QueuedForParsing: 2, Parsing: 3, ReadyForReview: 4, ParseFailed: 10 })
export function isImportParseReady(job) {
  return Boolean(job?.activeParseAttemptId &&
    (job?.status === importStatusValues.ReadyForReview || job?.status === 'ReadyForReview'))
}

export const parseStates = ['В очереди', 'Выполняется', 'Успешно', 'Ошибка', 'Отменён']
export const generationStates = [
  'В очереди', 'Формируется', 'Готов', 'Проверяется', 'Утверждён',
  'Ошибка формирования', 'Заменён', 'Недействителен'
]
export const operations = ['Создать', 'Обновить', 'Пропустить', 'Конфликт']
export const issueSeverities = ['Информация', 'Предупреждение', 'Ошибка']

export function enumLabel(labels, value) {
  if (typeof value === 'string') return value
  return labels[value] ?? `#${value}`
}

export function formatDate(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('ru-RU', {
    dateStyle: 'short', timeStyle: 'short'
  }).format(new Date(value))
}

export function formatMoney(value) {
  if (value === null || value === undefined) return '—'
  return new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0, maximumFractionDigits: 2
  }).format(value)
}

export function stateSeverity(value, type = 'job') {
  const text = String(value)
  if (type === 'parse' && (value === 2 || text === 'Succeeded')) return 'success'
  if (type === 'parse' && ([3, 4].includes(value) || /Failed|Cancelled/.test(text))) return 'danger'
  if (type === 'parse') return 'info'
  if (type === 'job' && (value === 4 || value === 5 || value === 8 || text === 'ReadyForReview' || text === 'Approved')) return 'success'
  if (type === 'generation' && (value === 2 || value === 4 || text === 'Ready' || text === 'Approved')) return 'success'
  if ([5, 6, 7, 10, 11].includes(value) || /Failed|Invalid|Error/.test(text)) return 'danger'
  if ([2, 3, 6, 7].includes(value) || /Queued|Generating|Parsing|Applying/.test(text)) return 'info'
  return 'secondary'
}

export function safeJson(value, fallback = {}) {
  if (value === null || value === undefined) return fallback
  if (typeof value === 'object') return value
  try { return JSON.parse(value) } catch { return fallback }
}

export function errorCode(error) {
  const raw = JSON.stringify(error?.raw ?? {})
  const match = raw.match(/IMPORT\.[A-Z0-9_.]+|DRAFT\.[A-Z0-9_.]+|MAPPING\.[A-Z0-9_.]+/)
  return match?.[0] ?? ''
}
